<template>
  <el-row>
    <el-row>
      <van-nav-bar :fixed="true"
        left-text="返回"
        left-arrow
        @click-left="back"
      />
      <el-row style="margin: 38px 0 8px">
        <el-row v-show="buttonVisiblePFWX">
          <mt-cell title="微信支付" v-on:click.native="doPay(payTypePFWX)" value="使用微信支付，方便快捷" style="min-height: 65px;" is-link>
            <img slot="icon" :src="wx" width="50" height="45">
          </mt-cell>
        </el-row>
        <el-row v-show="buttonVisiblePFZFB">
          <mt-cell title="支付宝支付" v-on:click.native="doPay(payTypePFZFB)" value="使用支付宝支付，方便快捷" style="min-height: 65px;" is-link>
            <img slot="icon" :src="zfb" width="50" height="45">
          </mt-cell>
        </el-row>
        <el-row v-show="buttonVisibleWX">
          <mt-cell title="微信支付" v-on:click.native="doPay(payType)" value="使用微信支付，方便快捷" style="min-height: 65px;" is-link>
            <img slot="icon" :src="wx" width="50" height="45">
          </mt-cell>
        </el-row>
        <el-row v-show="buttonVisibleZFB">
          <mt-cell title="支付宝支付" v-on:click.native="doPay(payTypeZFB)" value="使用支付宝支付，方便快捷" style="min-height: 65px;" is-link>
            <img slot="icon" :src="zfb" width="50" height="45">
          </mt-cell>
        </el-row>
        <el-row v-show="buttonVisibleUnion">
          <mt-cell title="银联支付" v-on:click.native="doPay(payTypeUnion)" value="使用银联支付，优惠多多" style="min-height: 65px;" is-link>
            <img slot="icon" :src="yl" width="50" height="45">
          </mt-cell>
        </el-row>
        <el-row>
          <mt-cell title="线下缴费" v-on:click.native="doPay('09')" value="前往财务处现场缴费(现金缴费)" style="min-height: 65px;" is-link>
            <van-icon name="cash-on-deliver" size="40" style="margin-right: 8px;" slot="icon" />
          </mt-cell>
        </el-row>
      </el-row>
    </el-row>
  </el-row>
</template>
<script>
export default {
  name: 'PayType',
  data: function () {
    return {
      // 控制参数
      buttonVisibleWX: false,
      buttonVisibleZFB: false,
      buttonVisibleUnion: false,
      buttonVisiblePFWX: false,
      buttonVisiblePFZFB: false,

      payType: '',
      payTypeZFB: '',
      payTypeUnion: '01',
      payTypePFWX: '',
      payTypePFZFB: '',
      // 图片
      wx: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/wx.png',
      yl: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/yl.png',
      zfb: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/zfb.png'
    }
  },
  mounted: function () {
    console.log('merchantListForPay', this.global.merchantListForPay)
    if (this.global.merchantListForPay.length > 0) {
      this.setVisiblePayButton(this.global.merchantListForPay)
    }
  },
  methods: {
    back: function () {
      this.$router.push({path: '/' + this.global.toPayObj.sourcePage})
    },
    setVisiblePayButton: function (merchantList) {
      var self = this
      // 设置支付方式的显示隐藏
      self.buttonVisibleUnion = false
      self.buttonVisibleWX = false
      self.buttonVisibleZFB = false
      self.buttonVisiblePFWX = false
      self.buttonVisiblePFZFB = false
      // 商户配置信息
      if (merchantList.length > 0) {
        merchantList.forEach(function (e) {
          if (e.payKind === '01') { // 银联
            self.payTypeUnion = e.payType
            self.buttonVisibleUnion = true
          }
          if (e.payKind === '02') { // 微信
            self.payType = e.payType
            self.buttonVisibleWX = true
          }
          if (e.payKind === '03') { // 支付宝
            self.payTypeZFB = e.payType
            self.buttonVisibleZFB = true
          }
          if (e.payKind === '07') { // 浦发新微信
            self.payTypePFWX = e.payType
            self.buttonVisiblePFWX = true
          }
          if (e.payKind === '08') { // 浦发新支付宝
            self.payTypePFZFB = e.payType
            self.buttonVisiblePFZFB = true
          }
        })
      }
    },
    // 支付
    doPay: function (payType) {
      var self = this
      let payUrl = ''
      // 根据不同支付方式访问不同的发起交易服务
      self.axios.post('/pay/toPay', {
        keyInfo: self.global.toPayObj.keyInfo,
        deptId: self.global.toPayObj.deptId,
        payType: payType,
        feeTermList: self.global.toPayObj.termList,
        validType: '02',
        userName: self.global.curStudent.studentName
      })
        .then(function (response) {
          if (response.data.result.success) {
            // 线下缴费：跳转到申请查询界面
            if (payType === '09') {
              self.$alert('申请提交成功！')
              self.route = [{ path: '/offlinePay', component: () => import('@/components/XiFan/NewStudent/OfflinePay.vue'), meta: { title: '线下缴费' } }]
              self.$router.addRoutes(self.route)
              self.$router.push('/offlinePay')
              return
            }
            let payKind = self.global.merchantListForPay.filter(item => item.payType === payType)[0].payKind
            if (payKind === '02') { // 微信支付
              payUrl += self.global.payUrl + 'pay/doPayForUrl?'
              payUrl += 'payType=' + payType
              payUrl += '&orderNo=' + response.data.orderNo
              payUrl += '&deptId=' + response.data.deptId
              payUrl += '&openId=' + self.global.curUser.openId
              payUrl += '&qrCodeType=' + 'WXPAY'
              payUrl += '&payChannel=01'
            } else if (payKind === '03') { // 支付宝
              payUrl += self.global.payUrl + 'pay/doPayForUrl?'
              payUrl += 'payType=' + payType
              payUrl += '&orderNo=' + response.data.orderNo
              payUrl += '&deptId=' + response.data.deptId
              payUrl += '&openId=' + self.global.curUser.openId
              payUrl += '&qrCodeType=' + 'ALIPAY'
              payUrl += '&payChannel=01'
            } else if (payKind === '07') { // 浦发微信支付 新版
              payUrl += self.global.payUrl + 'pay/doPayForUrl?'
              payUrl += 'payType=' + payType
              payUrl += '&orderNo=' + response.data.orderNo
              payUrl += '&deptId=' + response.data.deptId
              payUrl += '&openId=' + self.global.curUser.openId
              payUrl += '&qrCodeType=' + 'WXPAY'
              payUrl += '&payChannel=01'
            } else if (payKind === '08') { // 浦发支付宝支付 新版
              payUrl += self.global.payUrl + 'pay/doPayForUrl?'
              payUrl += 'payType=' + payType
              payUrl += '&orderNo=' + response.data.orderNo
              payUrl += '&deptId=' + response.data.deptId
              payUrl += '&openId=' + self.global.curUser.openId
              payUrl += '&qrCodeType=' + 'ALIPAY'
              payUrl += '&payChannel=01'
            } else { // 银联
              // 拼接支付地址
              payUrl += self.global.payUrl + 'pay/doPay?'
              payUrl += 'payType=' + payType
              payUrl += '&orderNo=' + response.data.orderNo
              payUrl += '&deptId=' + response.data.deptId
              payUrl += '&openId=' + self.global.curUser.openId
              payUrl += '&payChannel=01'
            }
            window.location.href = payUrl
          } else {
            self.$alert(response.data.result.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// PayType.vue?bd334988